import '../static/SectionHeader.css';
import React__default, { memo } from "react";
import clsx from "clsx";
import { u as useTagName } from "./useTagName.COq0HFfN.mjs";
import { c as Heading } from "./Heading.D9qZoTZe.mjs";
import { b as Paragraph } from "./Paragraph.DAcb0zW2.mjs";
import { b as Button } from "./Button.hIh6dJaA.mjs";
import { b as TextLink } from "./TextLink.gdbulXZb.mjs";
import { a as SolutionLogo } from "./SolutionLogo.Cu7IPBCl.mjs";
const sectionHeader = `_sectionHeader_dc3a84a`;
const centerXAlign = `_centerXAlign_fdcdd20`;
const leftXAlign = `_leftXAlign_11ccd3a`;
const label = `_label_be91224`;
const title = `_title_1a5dda6`;
const description = `_description_664ab8e`;
const actions = `_actions_8090e5f`;
const solutionLogo = `_solutionLogo_905f57d`;
const styles = { sectionHeader, centerXAlign, leftXAlign, label, title, description, actions, solutionLogo };
function trimButtons(buttonGroup) {
  if (buttonGroup == null ? void 0 : buttonGroup.length) {
    return buttonGroup.slice(0, 2);
  }
  return [];
}
const SectionHeaderActionsInner = ({ buttonGroup, textLink }) => {
  if (!(buttonGroup == null ? void 0 : buttonGroup.length) && !textLink) {
    return null;
  }
  const trimmedButtons = trimButtons(buttonGroup);
  const { label: textLinkLabel, ...textLinkProps } = textLink || {};
  return /* @__PURE__ */ React__default.createElement("div", { className: styles.actions, "data-ui-section-header-actions": true }, trimmedButtons.map(({ label: label2, ...action }, index) => {
    return /* @__PURE__ */ React__default.createElement(
      Button,
      {
        key: index,
        ...action,
        variant: index > 0 ? "secondary" : "primary"
      },
      label2
    );
  }), !trimmedButtons.length && (textLinkProps == null ? void 0 : textLinkProps.href) && /* @__PURE__ */ React__default.createElement(TextLink, { ...textLinkProps, arrow: "right" }, textLinkLabel));
};
const SectionHeaderActions = memo(SectionHeaderActionsInner);
const SECTION_HEADER_X_ALIGN = ["left", "center"];
const SECTION_HEADER_SEO_LEVEL = ["h1", "h2", "h3", "h4"];
const SectionHeader = ({
  as = "header",
  className,
  label: label2,
  title: title2,
  titleSize = "3xl",
  titleSeoLevel,
  description: description2,
  descriptionAs = "p",
  buttonGroup,
  solution,
  textLink,
  xAlign = "center",
  ...props
}) => {
  const Component = useTagName(as);
  return /* @__PURE__ */ React__default.createElement(
    Component,
    {
      className: clsx(
        styles.sectionHeader,
        styles[`${xAlign}XAlign`],
        className
      ),
      "data-ui": "section-header",
      ...props
    },
    solution && /* @__PURE__ */ React__default.createElement(
      SolutionLogo,
      {
        className: styles.solutionLogo,
        solution,
        variant: "primary"
      }
    ),
    !solution && label2 && /* @__PURE__ */ React__default.createElement("p", { className: styles.label, "data-ui-section-header-label": true }, label2),
    title2 && /* @__PURE__ */ React__default.createElement(
      Heading,
      {
        as: titleSeoLevel,
        size: titleSize,
        className: styles.title,
        "data-ui-section-header-title": true
      },
      title2
    ),
    description2 && /* @__PURE__ */ React__default.createElement(
      Paragraph,
      {
        className: styles.description,
        as: descriptionAs,
        "data-ui-section-header-description": true
      },
      description2
    ),
    /* @__PURE__ */ React__default.createElement(SectionHeaderActions, { buttonGroup, textLink })
  );
};
export {
  SECTION_HEADER_X_ALIGN as S,
  SECTION_HEADER_SEO_LEVEL as a,
  SectionHeader as b,
  SectionHeaderActions as c
};
//# sourceMappingURL=SectionHeader.VCo9GnTI.mjs.map
